(function ($) {
    var defaults = {
            elements: {},
            scrollObject: window,
            wrapObject: document
        };

    $.fn.scrollAnimation = function (settings) {
        if ($(this).length === 0) {
            return;
        }

        var options = $.extend(defaults, settings);
        var that = $(this);

        // Work out frame to work in for element
        that.data({
            'top': $(this).offset().top,
            'left': $(this).offset().left,
            'bottom': $(this).offset().top + $(this).height(),
            'right': $(this).offset().left + $(this).width(),
            'w': $(this).width(),
            'h': $(this).height(),
            'distance': 0
        });

        initialize.call(that);

        function initialize()
        {
            $(options.scrollObject).on('scroll.scrollAnimation', function (e) {
                var inViewport = isObjectInViewport.call(that);
                if (inViewport) {
                    that.addClass('in-frame');
                    calculateScrollDistance.call(that);
                    processElements.call(that);
                } else {
                    outOfBounds.call(that);
                    that.removeClass('in-frame');
                }
            }).triggerHandler('scroll.scrollAnimation');

            return true;
        }

        function isObjectInViewport()
        {
            // Find viewport range
            var vTop = $(options.scrollObject).scrollTop(),
                vBot = $(options.scrollObject).scrollTop() + $(options.scrollObject).height();

            return (
                ($(this).data('top') >= vTop && $(this).data('top') <= vBot) ||
                ($(this).data('bottom') >= vTop && $(this).data('bottom') <= vBot) ||
                ($(this).data('top') < vTop && $(this).data('bottom') > vBot)
            );
        }

        function calculateScrollDistance()
        {
            var distance = 0;

            // Reset out-of-bounds flags
            $(this).data('pastTop', false);
            $(this).data('pastBottom', false);

            // Find viewport range
            var vTop = $(options.scrollObject).scrollTop(),
                vBot = $(options.scrollObject).scrollTop() + $(options.scrollObject).height();

            if (vTop === $(this).data('top') && vBot === $(this).data('bottom')) {
                return 1;
            }

            var shown = vTop - $(this).data('top');
            var left = $(this).data('bottom') - vTop;

            // Shrink "left" value if the object is close enough to the bottom of the document that you cannot scroll past it fully
            if ($(options.wrapObject).height() - $(this).data('bottom') < $(options.scrollObject).height()) {
                var left_limit = $(options.scrollObject).height() - ($(document).height() - $(this).data('bottom'));
                left -= left_limit;
            }

            // Hack for pages where there's no scrolling
            if (shown === 0 && left === 0) {
                shown = 1;
                left = 0;
            }

            $(this).data('distance', shown / (shown + left));
            $(this).data('shown', shown);
            $(this).data('left', left);

            return true;
        }

        function outOfBounds()
        {
            var vTop = $(options.scrollObject).scrollTop(),
                vBot = $(options.scrollObject).scrollTop() + $(options.scrollObject).height();

            if (vTop > $(this).data('bottom')) {
                if (!$(this).data('pastBottom')) {
                    $(this).data('distance', 1);
                    $(this).data('pastBottom', true);
                    processElements.call(that);
                }
            } else if (vBottom < $(this).data('top')) {
                if (!$(this).data('pastTop')) {
                    $(this).data('distance', 0);
                    $(this).data('pastTop', true);
                    processElements.call(that);
                }
            }

            return true;
        }

        function processElements()
        {
            if (typeof options.elements !== 'object') {
                return false;
            }

            for (var ele in options.elements) {
                var distance = $(this).data('distance'),
                    start_keyframe = null, end_keyframe = null,
                    min_keyframe = null, max_keyframe = null;

                // Find minimum and maximum keyframe
                for (var keyframe in options.elements[ele]) {
                    var num = convertKeyframeToInt.call(that, keyframe);

                    if (min_keyframe === null || num < convertKeyframeToInt.call(that, min_keyframe)) {
                        min_keyframe = keyframe;
                    }
                    if (max_keyframe === null || num > convertKeyframeToInt.call(that, max_keyframe)) {
                        max_keyframe = keyframe;
                    }
                }

                // If first keyframe of this animation hasn't been reached yet, keep the styling of the first keyframe
                if ((distance * 100) <= convertKeyframeToInt.call(that, min_keyframe)) {
                    processElementStyles.call(that, ele, 0, options.elements[ele][min_keyframe], options.elements[ele][max_keyframe]);
                    continue;
                }
                // If last keyframe of this animation has been reached yet, keep the styling of the last keyframe
                if ((distance * 100) >= convertKeyframeToInt.call(that, max_keyframe)) {
                    processElementStyles.call(that, ele, 1, options.elements[ele][min_keyframe], options.elements[ele][max_keyframe]);
                    continue;
                }

                // Find current keyframe range
                for (var keyframe in options.elements[ele]) {
                    var num = convertKeyframeToInt.call(that, keyframe);

                    if (num >= (distance * 100)) {
                        end_keyframe = keyframe;
                        break;
                    } else {
                        start_keyframe = keyframe;
                    }
                }

                // Work out progress between keyframes
                var key_range = convertKeyframeToInt.call(that, end_keyframe) - convertKeyframeToInt.call(that, start_keyframe);
                var key_distance = ((distance * 100) - convertKeyframeToInt.call(that, start_keyframe)) / key_range;

                processElementStyles.call(that, ele, key_distance, options.elements[ele][start_keyframe], options.elements[ele][end_keyframe]);
            }

            return true;
        }

        function convertKeyframeToInt(keyframe)
        {
            if (keyframe === 'from') {
                return 0;
            } else if (keyframe === 'to') {
                return 100;
            } else if (typeof keyframe === 'string' && keyframe.indexOf('%') !== -1) {
                return (keyframe.replace('%', '') / 1);
            } else if (typeof keyframe === 'string' && /^[\-]*[0-9]+(\.[0-9]+)*px$/.test(keyframe) === true) {
                if ((keyframe.replace('px', '') / 1) == 0) {
                    return 0;
                }

                return (((keyframe.replace('px', '') / 1) / (this.data('shown') + this.data('left'))) * 100);
            } else {
                return keyframe;
            }
        }

        function processElementStyles(ele, distance, start, end)
        {
            for (var style in start) {
                if (end[style] !== undefined && typeof start[style] === typeof end[style]) {
                    var s_value = start[style],
                        e_value = end[style],
                        d_value = null;

                    // Find type of progress we need to find
                    if (typeof s_value === 'number' || /^[\-]*[0-9]+(\.[0-9]+)*$/.test(s_value) === true) {
                        var d_value = progressNumber(distance, s_value, e_value);
                    } else if (typeof s_value === 'string' && /^[\-]*[0-9]+(\.[0-9]+)*px$/.test(s_value) === true) {
                        var d_value = progressPixel(distance, s_value, e_value);
                    } else if (typeof s_value === 'string' && /^[\-]*[0-9]+(\.[0-9]+)*%$/.test(s_value) === true) {
                        var d_value = progressPercentage(distance, s_value, e_value);
                    } else if (typeof s_value === 'string' && /^#[0-9a-f]{6,8}$/i.test(s_value) === true) {
                        var d_value = progressHex(distance, s_value, e_value);
                    } else {
                        continue;
                    }

                    $(ele).css(style, d_value);
                }
            }

            return true;
        }

        function progressNumber(distance, start, end)
        {
            if (end < start) {
                var range = start - end;
                var progress = start - (range * distance);
            } else {
                var range = end - start;
                var progress = start + (range * distance);
            }
            return progress;
        }

        function progressPixel(distance, start, end)
        {
            start = (start.replace('px', '')) / 1;
            end = (end.replace('px', '')) / 1;

            return progressNumber(distance, start, end) + 'px';
        }

        function progressPercentage(distance, start, end)
        {
            start = (start.replace('%', '')) / 1;
            end = (end.replace('%', '')) / 1;

            return progressNumber(distance, start, end) + '%';
        }

        function progressHex(distance, start, end)
        {
            var start_colour = tinycolor(start),
                end_colour = tinycolor(end);

            // Get HSL and alpha values
            var start_hsl = start_colour.toHsl();
            var end_hsl = end_colour.toHsl();
            var target_hsl = {};

            if (start_hsl.h != end_hsl.h) {
                target_hsl.h = progressNumber(distance, start_hsl.h, end_hsl.h);
            } else {
                target_hsl.h = start_hsl.h;
            }
            if (start_hsl.s != end_hsl.s) {
                target_hsl.s = progressNumber(distance, start_hsl.s, end_hsl.s);
            } else {
                target_hsl.s = start_hsl.s;
            }
            if (start_hsl.l != end_hsl.l) {
                target_hsl.l = progressNumber(distance, start_hsl.l, end_hsl.l);
            } else {
                target_hsl.l = start_hsl.l;
            }
            if (start_hsl.a != end_hsl.a) {
                target_hsl.a = progressNumber(distance, start_hsl.a, end_hsl.a);
            } else {
                target_hsl.a = start_hsl.a;
            }

            // Set target colour
            var target_colour = tinycolor({
                h: target_hsl.h,
                s: target_hsl.s,
                l: target_hsl.l,
                a: target_hsl.a
            });

            return target_colour.toRgbString();
        }
    };
})(jQuery);
